class Faqs extends HTMLElement {
  constructor() {
    super();
    console.log('hi');
    this.questions = this.querySelectorAll('.faq__question');
    this.answers = this.querySelectorAll('.faq__answer');
    this.questions.forEach((q) => {
        q.addEventListener("click", () => { this.onFaqItemClick(q) })
    })
  }
  onFaqItemClick(questionEl) {
    this.hideAllFaqs(questionEl.nextElementSibling);
    questionEl.classList.toggle('active')
    questionEl.nextElementSibling.classList.toggle('hide_answer');
  }
  hideAllFaqs(currentClicked) {
    this.answers.forEach((answerEl) => {
        if (currentClicked != answerEl) {
        answerEl.previousElementSibling.classList.remove('active')
        answerEl.classList.add('hide_answer');
        }
    })
  }
}

customElements.define('faqs-sec', Faqs);
